import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const awardsReveal = () => {
	const sections = document.querySelectorAll(".awards-grid");

	if (!sections.length) return;

	const reduceMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)"
	).matches;

	sections.forEach((section) => {
		const items = section.querySelectorAll(".awards-grid__item");

		if (!items.length) return;

		if (reduceMotion) {
			gsap.set(items, {
				opacity: 1,
				y: 0,
			});

			return;
		}

		gsap.fromTo(
			items,
			{
				opacity: 0,
				y: 70,
			},
			{
				opacity: 1,
				y: 0,
				duration: 1.1,
				ease: "power3.out",
				stagger: 0.25,
				clearProps: "transform",
				scrollTrigger: {
					trigger: section,
					start: "top 75%",
					once: true,
				},
			}
		);
	});
};
